import PropTypes from "prop-types";
import withRouter from "components/Common/withRouter";
import React from "react";
import {
    Container,
    Row,
    Col,
    Form,
    FormGroup,
    Input,
    Button,
    Label
} from "reactstrap";
import icon1 from "../../assets/images/logo1.png";
import iconlogo from "../../assets/images/logo2.png";

const HomePage = (props) => {
    const currentDate = new Date();
    const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);


    return (
        <div className="homepage-bg min-vh-100 d-flex flex-column">
            <Container className="">
                <div className="d-flex align-items-center home-top-icon-pos">
                    <img src={icon1} alt="logo" className="me-2" />
                    <span className="fw-medium fs-4 home-page-color">Funnl</span>
                </div>
                <Row className="min-vh-100 align-items-center">
                    {/* Left Section */}
                    {!isMobile &&
                        <>
                            <Col md="6" className="d-flex flex-column">
                                {/* Logo at the top */}

                                {/* Centered content in remaining space */}
                                <div className="flex-grow-1 d-flex flex-column justify-content-center">
                                    <strong className="fw-bold lh-sm display-5 home-page-color">
                                        Revolutionizing how <br /> you hire.
                                    </strong>

                                    <p className="text-secondary mb-4 home-page-color fs-5">
                                        Funnl is helping companies hire better!
                                    </p>
                                    <div className="find-out-text">
                                        <p className="mb-2 fw-normal home-page-color fs-5">Want to find out more?</p>
                                        <p className="mb-2 fw-normal text-danger-right fs-5 fw-500">Enter Your Email<span className="text-danger text-danger-right">*</span></p>

                                        <Form className="email-form d-flex flex-wrap">
                                            <FormGroup className="mb-0 flex-grow-1">
                                                {/* <Label for="email" className="home-page-color">
                                        Enter your email
                                    </Label> */}
                                                <Input
                                                    id="email"
                                                    name="email"
                                                    placeholder="Enter your email"
                                                    type="email"
                                                    required
                                                    className="form-control-lg rounded-end-0"
                                                />
                                            </FormGroup>
                                            <Button className="subscribe-btn fw-medium px-4 rounded-start-0 fs-4">
                                                Subscribe
                                            </Button>
                                        </Form>
                                    </div>
                                </div>
                            </Col>
                            <Col
                                md="6"
                                className="text-center mt-5 mt-md-0 d-flex justify-content-center align-items-center big-image-position"
                            >
                                {/* <div className="bg-white shadow-sm d-inline-block logo-card"> */}
                                <img src={iconlogo} alt="Funnl logo" className="img-fluid" />
                                {/* </div> */}
                            </Col>
                        </>
                    }

                    {isMobile &&
                        <>
                            <Col md="6" className="d-flex flex-column px-3 px-md-0">
                                <div className="flex-grow-1 d-flex flex-column justify-content-center">
                                    <strong className="fw-bold lh-sm display-5 home-page-color">
                                        Revolutionizing how <br /> you hire.
                                    </strong>

                                    <p className="text-secondary mb-4 home-page-color fs-5">
                                        Funnl is helping companies hire better!
                                    </p>

                                    <div className="find-out-text">
                                        <p className="mb-2 fw-normal home-page-color fs-5">Want to find out more?</p>
                                        <p className="mb-2 fw-normal text-danger-right fs-5 fw-500">
                                            Enter Your Email<span className="text-danger text-danger-right">*</span>
                                        </p>

                                        <Form className="email-form d-flex flex-column flex-sm-row flex-wrap gap-2">
                                            <FormGroup className="flex-grow-1 mb-2 mb-sm-0">
                                                <Input
                                                    id="email"
                                                    name="email"
                                                    placeholder="Enter your email"
                                                    type="email"
                                                    required
                                                    className="form-control-lg rounded-end-0"
                                                />
                                            </FormGroup>
                                            <Button className="subscribe-btn fw-medium px-4 rounded-start-0 fs-4">
                                                Subscribe
                                            </Button>
                                        </Form>
                                    </div>
                                </div>
                            </Col>

                            <Col
                                md="6"
                                className="text-center mt-5 mt-md-0 d-flex justify-content-center align-items-center big-image-position px-3 px-md-0"
                            >
                                <img src={iconlogo} alt="Funnl logo" className="img-fluid" style={{ maxWidth: '100%', height: 'auto' }} />
                            </Col>
                        </>
                    }


                    {/* Right Section */}
                </Row>
                <footer className="text-center py-3 small text-secondary fs-6 mt-auto">
                    ©{currentDate?.getFullYear()} Powered by{" "}
                    <a href="https://ancile.services" className="text-primary text-decoration-none" target="_blank" rel="noopener noreferrer">
                        Ancile Services
                    </a>{" "}
                    |{" "}
                    <a href="/PrivacyPolicy" className="text-primary text-decoration-none">
                        Privacy Policy
                    </a>
                </footer>
            </Container>

            {/* Footer */}

        </div>
    );
};

export default withRouter(HomePage);

HomePage.propTypes = {
    history: PropTypes.object,
};
